import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TagsManage from '@/views/marketing/marketingManage/tagsManage/index.vue'


const __default__ = { name: 'DcCosFbuTagManage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const permission = {
  add: 'fbu_tags_add_btn',
  edit: 'fbu_tags_edit_btn',
  del: 'fbu_tags_del_btn',
  enable: 'fbu_tags_enable_btn',
  disable: 'fbu_tags_disable_btn'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TagsManage, {
    subdomain: "fbu",
    permission: permission
  }))
}
}

})